import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { GlobalService } from './global.service';

const devUrl = environment.backendurl;

/**
 * Data structure of each request object for talent insights export
 */
export interface ExportRequest {
    type: string
    action?: string
    data: { 
        currentTab: string 
    }
}

/**
 * Data structure of each service payload object for talent insights export
 */
export interface ExportPayload {
    type?: string
    tab: string
    totalresultcount?: number
    data?: any
    aiData?: string
    aiRequestFilters?: any
    aiRequestPayload?: any[]
    [key: string]: any
}

@Injectable({
  providedIn: 'root'
})

export class TalentInsightsService {
    public companyData: any

    /**
     * Observable for handling insights-export request signal
     */
    private insightsExportRequestObservable: Subject<any> = new Subject();
    /**
     * Observable for handling insights-export data sharing
     */
    private insightsExportDataObservable: Subject<any> = new Subject();

    constructor(private http: HttpClient) { }

    /**
     * Getter for insights-export request observable
     */
    get insightsExportRequestEvent(): Observable<any> {
        return this.insightsExportRequestObservable.asObservable();
    }
    /**
     * Getter for insights-export request observable
     */
    get insightsExportDataEvent(): Observable<any> {
        return this.insightsExportDataObservable.asObservable();
    }
    /**
     * Send request for insights export
     * @param requestData 
     */
    sendInsightsExportRequest(requestData: ExportRequest) {
        this.insightsExportRequestObservable.next(requestData);
    }
    /**
     * Emit data for insights export
     * @param exportData 
     */
    sendInsightsExportData(exportData: ExportPayload) {
        this.insightsExportDataObservable.next(exportData);
    }

    /**
     * Export talent insights report to PDF
     * @param payload 
     */
    exportInsightsToPDFReport(payload: any): Observable<any> {
        const url = devUrl + `/personsearch/talent/insights/export`;
        return this.http.post(url, payload).pipe(map(response => { return response; })
        , catchError(GlobalService.handleError('Company Insights Export to PDF', url)));
    }

}
